export default "__VITE_ASSET__DMd2LEqU__"